import { Injectable } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { NgGridStackOptions } from 'gridstack/dist/angular';
import { BehaviorSubject } from 'rxjs';
import { DashboardnameValidator } from '../validator/dashboardnameAsyncValidator';
import { DashboardBuilderService } from './dashboard-builder.service';


interface PanelState {
  isExpanded: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class DashboardBuilderVarService {
    panelState$: BehaviorSubject<PanelState> = new BehaviorSubject<PanelState>({
        isExpanded: true
    });

    constructor(public dashboardBuilderService:DashboardBuilderService){

    }
    default_color_palette = "#a6d4e7"
    default_time_range = "Last 7 days"
    colorPaletteList = ["#a6d4e7","#0081b8","#737373","#454545","#e0eff6","#9e57bc"]
    timeRangeList = ["Today","Yesterday","Last 7 days","Last 30 days"]
    colorPalette = new FormControl(this.default_color_palette)
    timeRange = new FormControl(this.default_time_range)
    dbHeaderLabels = {"color_palette":"Color palette","time_range":"Time range","preview":"PREVIEW","cancel":"CANCEL",
    "publish":"PUBLISH","data_source":"Data source","visualizations":"Visualizations",
    "datasource_placeholder":"Select Sources...",
    "visuals_placeholder":"Select Chart...",
    "widget_filter":"Charts Filter",
    "widgets":"Charts",
    "widget_layout":"Layout",
    "db_title":"Title",
    "db_title_placeholder":"Dashboard name",
    "fields":"Fields",
    "fields_placeholder":"Select Fields..."
  }

    data_source_map = {}
    dashboard_preview_mode:string = "preview";

    dashboardMode:boolean = false

    dashboard_id:number = 0;

    cellHeight: number

    dynamicOffset = window.innerHeight * 0.0037;
    nestedGridOptions: NgGridStackOptions = { // main grid options
        // cellHeight: (window.innerHeight / 12)+ this.dynamicOffset,
        // cellHeight: 'auto',
        float: true,
        margin: 5,
        minRow: 10, // don't collapse when empty
        acceptWidgets: true,
        disableResize: false,
        disableDrag: false,
        // columnOpts: {
        //   breakpoints: [
        //     { w: 768, c: 1 },
        //     { w: 1200, c: 6 },
        //     { w: 1600, c: 10 },
        //     { w: 9999, c: 12 }
        //   ]
        // }
        // subGridOpts: this.subOptions, // all sub grids will default to those
        // children: this.subChildren,
        // acceptWidgets: '.new-widget'
      };

      titleError={
        "invalidName":"Spaces and special characters are not allowed",
        "required": "Title is required",
        "maxlength": "Title doesn't exceed 200 characters",
        "dashboardNameAlreadyExists": "already exist"
      }
  
      toaster_messages = {
        "post_success":"Dashboard posted successfully",
        "post_fail":"Dashboard post failed",
        "dashboard_empty":"Dashboard is empty!"
      }

    widget_filters =  {
      "platform": [
          {
              "disp": "Switch",
              "value": "Switch"
          },
          {
              "disp": "Firewall",
              "value": "Firewall"
          },
          {
              "disp": "Router",
              "value": "Router"
          }
      ],
      "devices": {
          "Firewall": [
              {
                  "disp": "Cisco.Firepower",
                  "value": 26
              },
              {
                  "disp": "Fortinet.Fortigate",
                  "value": 22
              },
              {
                  "disp": "Paloalto",
                  "value": 27
              }
          ],
          "Router": [
              {
                  "disp": "Cisco",
                  "value": 24
              }
          ],
          "Switch": [
              {
                  "disp": "Cisco",
                  "value": 25
              }
          ]
      },
      "data_source":[
            {
                "disp": "Fortinet.Multidimensional ",
                "value": 2
            },
            {
                "disp": "Fortinet.Singledimensional.Device",
                "value": 1
            }
      ],
      "fields":[
        {
          "disp":"action",
          "value":"action"
        },
        {
          "disp":"srcip",
          "value":"srcip"
        },
        {
          "disp":"dstip",
          "value":"dstip"
        },
        {
          "disp":"service",
          "value":"service"
        }
      ],
      "visualizations":[
        {
          "disp":"Line",
          "value":"line"
        },
        {
          "disp":"Bar",
          "value":"bar"
        },
        {
          "disp":"Sankey",
          "value":"sankey"
        },
        {
          "disp":"Polar",
          "value":"polar"
        },
        {
          "disp":"Radial",
          "value":"radial"
        },
        {
          "disp":"Treemap",
          "value":"treemap"
        },
        {
          "disp":"Pie",
          "value":"pie"
        },
        {
          "disp":"Table",
          "value":"table"
        }
      ]
    }


    // widgets_details = [
    //   {selector: 'widget-wrapper', type: 'line', title: 'Line Chart', minW:2,maxW:4,minH:1,maxH:2, id: '111', data_source: 1, platform: 27, device: 1, fields: [], icon: "assets/widgets/line-chart.svg", time_range: "Last 30 days"},
    //   { selector: 'widget-wrapper', type: 'table', title: 'Data Table', minW:2,maxW:4,minH:1,maxH:2, id: '112', data_source: 1, platform: 27, device: 1, fields: ["action"], icon: "assets/widgets/line-chart.svg", time_range: "Last 30 days" },
    //   { selector: 'widget-wrapper', type: 'bar', title: 'KPI Card', minW:2,maxW:4,minH:1,maxH:2, id: '113', data_source: 2, platform: 27, device: 1, fields: [], icon: "assets/widgets/line-chart.svg", time_range: "Last 30 days" }
    // ]

    widgets_details = [
      
    ]


    layout_details = [
      {"id":1,
        "name":"Section header"
      },
      {
        "id":2,
        "name":"Static widgets"
      }
    ]

    chartData = {"113":{
    "xAxis": {
        "type": "category",
        "data": [
            "DNS",
            "DNS",
            "HTTPS",
            "DNS",
            "DNS",
            null,
            null,
            "DNS",
            "DNS",
            "DNS",
            null,
            null,
            null,
            "DNS",
            null,
            null,
            null,
            "DNS",
            "DNS",
            null,
            "DNS",
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            "DNS",
            "DNS",
            "HTTP",
            null,
            "DNS",
            null,
            "DNS",
            null,
            "DNS",
            "HTTPS",
            null,
            "DNS",
            "DNS",
            null,
            "DNS",
            null,
            null,
            "HTTPS",
            "DNS",
            "DNS",
            "DNS",
            "HTTPS",
            null,
            null,
            "DNS",
            "DNS",
            "HTTPS",
            "DNS",
            "HTTPS",
            "DNS",
            "DNS",
            "DNS",
            "DNS",
            "HTTPS",
            null,
            "DNS",
            null,
            null,
            "DNS",
            "DNS",
            null,
            "DNS",
            null,
            "DNS",
            "DNS",
            null,
            null,
            "DNS",
            "DNS",
            "HTTPS",
            null,
            null,
            null,
            "DNS",
            "DNS",
            "DNS",
            "DNS",
            null,
            "HTTPS",
            "HTTPS",
            "DNS",
            "HTTPS",
            "DNS",
            "DNS",
            null,
            "HTTPS",
            null,
            null,
            null,
            "HTTP",
            null
        ]
    },
    "yAxis": {
        "type": "value"
    },
    "series": [
        {
            "type": "bar",
            "data": [
                1035076,
                3843922,
                0,
                1300224,
                1234020,
                0,
                0,
                1125480,
                1096100,
                1056980,
                0,
                0,
                0,
                1171516,
                0,
                0,
                0,
                1105284,
                123184,
                0,
                63296,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                530,
                7976,
                8208,
                0,
                710432,
                0,
                31800,
                0,
                82840,
                0,
                0,
                6958,
                298,
                0,
                7136,
                0,
                0,
                15049428,
                31920,
                191248,
                23432,
                0,
                0,
                0,
                1384,
                42632,
                0,
                6120,
                388476,
                5304,
                23744,
                4144,
                124960,
                122744,
                0,
                40856,
                0,
                0,
                1056,
                9736,
                0,
                19958,
                0,
                111824,
                36134,
                0,
                0,
                9532,
                240,
                13272,
                0,
                0,
                0,
                9870,
                7140,
                1418,
                1888,
                0,
                3608,
                0,
                308,
                993352,
                196,
                3764,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "name": "rcvdbyte"
        },
        {
            "type": "bar",
            "data": [
                859680,
                1604470,
                0,
                979842,
                962008,
                0,
                0,
                882624,
                896250,
                839832,
                0,
                0,
                0,
                929922,
                0,
                0,
                0,
                838270,
                3232,
                0,
                1056,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                360,
                504,
                5892,
                0,
                680958,
                0,
                528,
                0,
                3200,
                0,
                0,
                5120,
                160,
                0,
                4166,
                0,
                0,
                270260,
                552,
                5360,
                40246,
                0,
                0,
                0,
                982,
                64764,
                0,
                4470,
                18126,
                2362,
                40690,
                1008,
                4096,
                12248,
                0,
                2080,
                0,
                0,
                1056,
                1040,
                0,
                10240,
                0,
                3912,
                2696,
                0,
                0,
                7166,
                150,
                12788,
                0,
                0,
                0,
                5780,
                4608,
                808,
                1494,
                0,
                3000,
                0,
                196,
                36116,
                164,
                2294,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "name": "sentbyte"
        }
    ]
    } 
  }

  relativeTimeMetadata = [
    {
      "disp": "Today",
      "value": [
        0,
        "today",
        0
      ]
    },
    {
      "disp": "Yesterday",
      "value": [
        -1,
        "yesterday",
        1
      ]
    },
    {
      "disp": "last 7 Days",
      "value": [
        -1,
        "day",
        6
      ]
    },
    {
      "disp": "Last 30 Days",
      "value": [
        -1,
        "day",
        29
      ]
    }
  ]

    filtered_widgets:any = []

    filterAccordian:boolean = false;
    widgetsAccordian:boolean = true;
    widgetLayoutAccordian:boolean = false;
    dashboard_builder_mode = "new";

    dashboard_name = new FormControl('',{
          validators:[Validators.required,Validators.maxLength(100),Validators.pattern('^(?!\\s+$)[a-zA-Z0-9 _-]+$')],
          asyncValidators: [DashboardnameValidator.createValidator(this.dashboardBuilderService, this)]
        });
    widgets_filters_group = new FormGroup({
      data_source:new FormControl([]),
      visualizations:new FormControl([]),
      fields:new FormControl([])
    })

  
    get data_source() {
      return this.widgets_filters_group.get('data_source') as UntypedFormControl
    }

    get visualizations() {
      return this.widgets_filters_group.get('visualizations') as UntypedFormControl
    }

    get fields() {
      return this.widgets_filters_group.get('fields') as UntypedFormControl
    }


    updatePanelState(state: PanelState): void {
        this.panelState$.next(state);
    }

    resetDashboardBuilder(){
      // console.log("Reset Dashboard")
      this.filterAccordian = false;
      this.widgetsAccordian = true;
      this.widgetLayoutAccordian = false;
      this.dashboard_builder_mode = "new";
      this.dashboard_preview_mode = "preview";
      this.dashboard_id = 0;
      this.dashboard_name.reset('')
      this.dashboard_name.enable()
      this.data_source.reset([])
      this.visualizations.reset([])
      this.fields.reset([])
      this.nestedGridOptions = { // main grid options
        // cellHeight: (window.innerHeight / 12)+this.dynamicOffset,
        // cellHeight :this.cellHeight/12,
        // cellHeight: 'auto',
        float: true,
        margin: 5,
        minRow: 10, // don't collapse when empty
        acceptWidgets: true,
        disableResize: false,
        disableDrag: false,
        // columnOpts: {
        //   breakpoints: [
        //     { w: 768, c: 1 },
        //     { w: 1200, c: 6 },
        //     { w: 1600, c: 10 },
        //     { w: 9999, c: 12 }
        //   ]
        // }
        // subGridOpts: this.subOptions, // all sub grids will default to those
        // children: this.subChildren,
        // acceptWidgets: '.new-widget'
      };
    }


}